import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { AppShell } from '@/components/layout/AppShell';
import Auth from '@/pages/Auth';
import NotFound from '@/pages/NotFound';
import UniversalDashboard from '@/pages/dashboard/UniversalDashboard';
import Settings from '@/pages/Settings';
import AssetRegister from '@/pages/AssetRegister';
import RigRegister from '@/pages/RigRegister';
import Devices from '@/pages/Devices';
import Patterns from '@/pages/Patterns';
import AdminUsers from '@/pages/AdminUsers';
import AdminOrganisation from '@/pages/AdminOrganisation';
import Approvals from '@/pages/Approvals';
import ShiftLogs from '@/pages/ShiftLogs';
import ScanForm from '@/pages/ScanForm';
import ProtectedRoute from '@/components/guards/ProtectedRoute';
const queryClient = new QueryClient();

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <BrowserRouter>
                    <Toaster richColors position='top-right' />
                    <Routes>
                        <Route path='/auth' element={<Auth />} />
                        <Route element={<ProtectedRoute />}>
                            <Route element={<AppShell />}>
                                {/* StrataWorks is the root — no /dashboard subpath. */}
                                <Route path='/' element={<UniversalDashboard />} />
                                <Route path='/dashboard' element={<Navigate to='/' replace />} />
                                <Route path='/approvals' element={<Approvals />} />
                                <Route path='/shift-logs' element={<ShiftLogs />} />
                                <Route path='/scan-form' element={<ScanForm />} />
                                <Route path='/settings' element={<Settings />} />
                                <Route path='/asset-register' element={<AssetRegister />} />
                                <Route path='/rigs' element={<RigRegister />} />
                                <Route path='/devices' element={<Devices />} />
                                <Route path='/patterns' element={<Patterns />} />
                                <Route path='/admin/users' element={<AdminUsers />} />
                                <Route path='/admin/organisation' element={<AdminOrganisation />} />
                            </Route>
                        </Route>
                        <Route path='*' element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </QueryClientProvider>
    );
}
